import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const downloadAPI = createApi({
    reducerPath: "downloadAPI",
    baseQuery,
    endpoints: (builder) => ({
        getUploadNDownloadURL: builder.mutation({
            query: ({ type, modelName }) => {
                let apiUrl = `admin/document/upload?type=${type}&modelName=${modelName}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        })
    })
});

export const { 
    useGetUploadNDownloadURLMutation,
} = downloadAPI;

export default downloadAPI;